import React from "react";
import { useOutletContext, Link } from "react-router-dom";
import { KeyRound, User, Mail, Building2 } from "lucide-react";

export default function BusinessSettingsPage() {
  const { user, customer } = useOutletContext();
  return (
    <div className="space-y-6 max-w-2xl" data-testid="business-settings-page">
      <div>
        <div className="text-xs uppercase tracking-wider text-brand-red font-semibold">Indstillinger</div>
        <h1 className="font-display font-bold text-3xl text-brand-dark mt-1">Konto & profil</h1>
      </div>

      <div className="bg-white border border-brand p-5 space-y-3">
        <div className="flex items-center gap-3"><Building2 size={20} className="text-brand-red"/>
          <div>
            <div className="text-xs text-brand-text2">Virksomhed</div>
            <div className="font-semibold text-brand-dark">{customer?.company_name}</div>
            {customer?.cvr && <div className="text-xs text-brand-text2">CVR {customer.cvr}</div>}
          </div>
        </div>
        <hr/>
        <div className="flex items-center gap-3"><User size={20} className="text-brand-red"/>
          <div>
            <div className="text-xs text-brand-text2">Dit navn</div>
            <div className="font-semibold text-brand-dark">{user?.name || "—"}</div>
          </div>
        </div>
        <div className="flex items-center gap-3"><Mail size={20} className="text-brand-red"/>
          <div>
            <div className="text-xs text-brand-text2">Email</div>
            <div className="font-semibold text-brand-dark">{user?.email}</div>
          </div>
        </div>
        <div className="text-xs text-brand-text2">
          Vil du opdatere firma-info? Kontakt EMA Kurer på <a href="mailto:kontakt@emakurer.dk" className="underline">kontakt@emakurer.dk</a>
        </div>
      </div>

      <Link to="/business/change-password" className="bg-white border border-brand p-5 flex items-center gap-3 hover:border-brand-red transition-colors" data-testid="biz-settings-change-pw">
        <KeyRound size={20} className="text-brand-red"/>
        <div>
          <div className="font-semibold text-brand-dark">Skift kodeord</div>
          <div className="text-xs text-brand-text2">Opdater dit login-kodeord</div>
        </div>
      </Link>
    </div>
  );
}
